import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actionCreators } from '@/checkout-instore-legacy/returnExchange/actions'
import { openRootModalWithDialog } from '@/checkout-instore-legacy/rootModal/actions'
import { customerProfileSelector } from '@/checkout-instore-legacy/returnExchange/selectors'

import ExchangeSummary from '../components/ExchangeSummary'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...actionCreators, openRootModalWithDialog }, dispatch)

const mapStateToProps = (state) => ({
  order: state.returnExchange.order,
  errors: state.returnExchange.errors,
  itemMap: state.returnExchange.itemMap,
  profile: customerProfileSelector(state),
  giftcardLoading: state.returnExchange.giftcardLoading,
  itemLoading: state.returnExchange.itemLoading,
})

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeSummary)
